"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TimeLimitInfoPrompt = void 0;
var react_1 = __importDefault(require("react"));
var luxon_1 = require("luxon");
var BemBuilder_1 = __importDefault(require("@CommonFrontend/Utils/BemBuilder"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var c = (0, BemBuilder_1.default)("auto-link-expiry__time-expiry-prompt");
function TimeLimitInfoPrompt(_a) {
    var timeLimit = _a.timeLimit, wasTimeLimitDisabledThisSession = _a.wasTimeLimitDisabledThisSession;
    if ((timeLimit === null || timeLimit === void 0 ? void 0 : timeLimit.forever) === true && !wasTimeLimitDisabledThisSession) {
        return null;
    }
    var fromDateElement;
    var untilDateElement = react_1.default.createElement(react_1.default.Fragment, null, "until forever");
    if (timeLimit.from) {
        fromDateElement = (react_1.default.createElement(react_1.default.Fragment, null,
            "from ",
            react_1.default.createElement("strong", null, luxon_1.DateTime.fromJSDate(new Date(timeLimit.from)).toLocaleString(luxon_1.DateTime.DATE_FULL))));
    }
    if (timeLimit.until) {
        untilDateElement = (react_1.default.createElement(react_1.default.Fragment, null,
            "until ",
            react_1.default.createElement("strong", null, luxon_1.DateTime.fromJSDate(new Date(timeLimit.until)).toLocaleString(luxon_1.DateTime.DATE_FULL))));
    }
    return (react_1.default.createElement("div", { className: c() },
        react_1.default.createElement(kaleidoscope_1.Alert, { heading: "Time Limit Feature is Changing", theme: kaleidoscope_1.AlertTheme.Dark },
            react_1.default.createElement("div", { className: c("time-expiry-content") },
                react_1.default.createElement(react_1.default.Fragment, null, wasTimeLimitDisabledThisSession ? (react_1.default.createElement("div", null, "Time Limit has been disabled. The original values were:")) : (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement("div", null, "This page has a Time Limit. That feature will soon be updated, but this page still works."),
                    react_1.default.createElement("div", null, "Going forward, use Link Expiry to set time limits. You can enable it on this page now if you prefer.")))),
                react_1.default.createElement("div", null,
                    "The page is valid ",
                    fromDateElement,
                    " ",
                    untilDateElement),
                react_1.default.createElement("p", { className: c("warning") }, wasTimeLimitDisabledThisSession
                    ? "This message will not appear again"
                    : "If you enable Link Expiry for this page, the Time Limit will be disabled")))));
}
exports.TimeLimitInfoPrompt = TimeLimitInfoPrompt;
